export function logoutAndRedirect() {
    sessionStorage.clear();
    if (window && window.location) {
        window.location = '/login';
    }
}

export function authHeader() {
    // return authorization header with jwt token from sessionStorage
    const token = sessionStorage.getItem('token');

    if (token) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logoutAndRedirect();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}